import { Injectable } from "@angular/core";
import {Observable} from "rxjs/Observable";
import {Language} from "./language.model";
import {environment} from "../../../app/config/environment";
import {MyHttp} from "../../../app/core/http";

@Injectable()
export class LanguageService {

  constructor(private http: MyHttp) {}

  getLanguages(): Observable<Language[]> {
    return this.http.get(environment.API + '/languages')
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/pages/shared/language/language.service.ts